// THREE Core Classes
export * from 'three';
import { PluginRegistry } from './PluginRegistry.js';
import i18nManager from './i18nManager.js';
import Auth from './../login/auth.js';
export * from './StudioPlugin.js';

// ensure singleton
const ALCHEM_GLOBAL_KEY = Symbol.for("DA_STUDIO.SingletonHolder");
var globalSymbols = Object.getOwnPropertySymbols(global);

if (globalSymbols.indexOf(ALCHEM_GLOBAL_KEY) === -1) {
    // define globals here
    global[ALCHEM_GLOBAL_KEY] = {
        version: "1.2",
        name: "DA-Studio",
        pluginRegistry: new PluginRegistry(),
        i18n: new i18nManager(),
        auth: new Auth()
    };
}

var singleton = {};

Object.defineProperty(singleton, "instance", {
    get: function () {
        return global[ALCHEM_GLOBAL_KEY];
    }
});

Object.freeze(singleton);

export let ALCHEMISTEN = singleton;


// WEBPACK FOOTER //
// ./src/js/define/three-declare.js